var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info',[_c('h1',[_vm._v(_vm._s(_vm.$t("PRIVACY POLICY")))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('PRIVACY_POLICY_DESC_1'))}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('PRIVACY_POLICY_DESC_2'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }